<template>
  <ul :class="$style.root">
    <slot />
  </ul>
</template>

<style module lang="scss">
.root {
  --columns: 2;
  --step: calc(100% / var(--columns));
  --stroke: var(--core-box-list--stroke, var(--stroke--default));
  --color: var(--core--box-list--color, var(--color--primary));
  --gap: var(--unit--default);

  composes: reset-list from global;

  display: grid;
  grid-template-columns: repeat(var(--columns), 1fr);

  position: relative;

  border-top: var(--stroke) solid;
  border-left: var(--stroke) solid;
  border-right: var(--stroke) solid;

  z-index: 1;

  @media (max-width: $breakpoint-s) {
    --columns: 1;
    --gap: 0;

    border-bottom: 0;
  }
}

.root:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: repeating-linear-gradient(90deg, transparent, transparent var(--step), var(--color) var(--step), var(--color) calc(var(--step) + var(--stroke)));
  z-index: 1;
  pointer-events: none;
}

.root:before {
  content: '';
  display: block;
  position: absolute;


  right: 0;
  bottom: 0;
  left: 0;

  border-bottom: var(--stroke) solid;

  z-index: 1;
  pointer-events: none;
}
</style>
